export const getRecordFromURLSearchParams = ({
  urlSearchParams,
  keyName,
}: {
  urlSearchParams: URLSearchParams;
  keyName: string;
}) =>
  (urlSearchParams.get(keyName)?.split(',') || []).reduce(
    (prev, val) => ((prev[val] = true), prev),
    {} as Record<string, boolean>,
  );
